export default __webpack_public_path__ + "static/media/chat-icon5.02172519.svg";